export const ATTENDANCE_TIME_ZONE = 'Asia/Kolkata';

const dateTimeFormatter = new Intl.DateTimeFormat('en-IN', {
  timeZone: ATTENDANCE_TIME_ZONE, year: 'numeric', month: '2-digit', day: '2-digit',
  hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true,
});
const dateFormatter = new Intl.DateTimeFormat('en-IN', {
  timeZone: ATTENDANCE_TIME_ZONE, year: 'numeric', month: '2-digit', day: '2-digit',
});
const dateKeyFormatter = new Intl.DateTimeFormat('en-CA', {
  timeZone: ATTENDANCE_TIME_ZONE, year: 'numeric', month: '2-digit', day: '2-digit',
});

const parseAttendanceDateTime = (value) => {
  if (value instanceof Date) return value;
  const text = String(value || '').trim();
  if (!text) return null;
  // Database timestamps without an offset represent wall-clock time in Kolkata.
  const normalized = /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}/.test(text) && !/(?:Z|[+-]\d{2}:?\d{2})$/.test(text)
    ? `${text.replace(' ', 'T')}+05:30`
    : text;
  const date = new Date(normalized);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const formatDateTime = (value) => {
  const date = parseAttendanceDateTime(value);
  return date ? dateTimeFormatter.format(date) : '-';
};

export const formatDate = (value) => {
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
  const date = parseAttendanceDateTime(value);
  return date ? dateFormatter.format(date) : '-';
};

export const todayDate = () => dateKeyFormatter.format(new Date());

export const currentMonthKey = () => todayDate().slice(0, 7);

export const moveMonthKey = (month, amount) => {
  const match = /^(\d{4})-(0[1-9]|1[0-2])$/.exec(month || '');
  if (!match) return currentMonthKey();
  const total = Number(match[1]) * 12 + Number(match[2]) - 1 + amount;
  const year = Math.floor(total / 12);
  return `${year}-${String(total - year * 12 + 1).padStart(2, '0')}`;
};

export const weekdayForDateKey = (dateKey) => {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateKey || '');
  return match ? new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3])).getDay() : 0;
};
